import {
  DASH_SET_LOADING, DASH_SET_ERROR, DASH_SET_META, DASH_SET_TOPIC,
  DASH_SET_PAYLOAD, DASH_SET_NOTFOUND
} from './dashboardActions';

const initial = {
  loading: false,
  error: null,
  notFound: false,
  meta: null,      // { titulo, topics }
  topic: null,     // 'feedbackLojas', etc.
  payload: null    // dados do tópico ativo
};

export default function dashboardReducer(state = initial, action) {
  switch (action.type) {
    case DASH_SET_LOADING:  return { ...state, loading: action.payload };
    case DASH_SET_ERROR:    return { ...state, error: action.payload };
    case DASH_SET_NOTFOUND: return { ...state, notFound: action.payload, meta: null, payload: null };
    case DASH_SET_META:     return { ...state, meta: action.payload };
    case DASH_SET_TOPIC:    return { ...state, topic: action.payload, payload: null };
    case DASH_SET_PAYLOAD:  return { ...state, payload: action.payload };
    default: return state;
  }
}
